import { Route } from "@angular/router";

export const SettingsPaths = {
  Settings: "settings",
  KanIkHelpen: "kanikhelpen",
  WorkingYears: "werkjaren",
  Debug: "debug",
  Account: "account",
};

export default [
  {
    path: SettingsPaths.Settings,
    loadComponent: () =>
      import("./pages/settings/settings.component").then((c) => c.SettingsComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Voorkeuren en instellingen",
      subscriptionTypes: [1],
    },
  },
  {
    path: SettingsPaths.KanIkHelpen,
    loadComponent: () =>
      import("./pages/kanikhelpen/kanikhelpen.component").then((c) => c.KanikhelpenComponent),
    data: {
      breadcrumb: "kanikhelpen.be",
      title: "kanikhelpen.be",
      subscriptionTypes: [1],
    },
  },
  {
    path: SettingsPaths.WorkingYears,
    loadComponent: () =>
      import("./pages/workingyear-list/workingyear-list.component").then(
        (c) => c.WorkingyearListComponent
      ),
    data: {
      breadcrumb: "Werkjaren",
      title: "Werkjaren",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: SettingsPaths.Debug,
    loadComponent: () => import("./pages/debug/debug.component").then((c) => c.DebugComponent),
    data: {
      breadcrumb: "Problemen oplossen",
      title: "Problemen oplossen",
    },
  },
  {
    path: SettingsPaths.Account,
    loadComponent: () =>
      import("../users/pages/my-user-edit/my-user-edit.component").then(
        (c) => c.MyUserEditComponent
      ),
    data: {
      breadcrumb: "Mijn gebruikersaccount",
      title: "Mijn gebruikersaccount",
    },
  },
] satisfies Route[];
